"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiLink = void 0;
var colors_1 = require("../colors");
exports.MuiLink = {
    defaultProps: {
        underline: 'none',
    },
    styleOverrides: {
        root: {
            fontSize: '14px',
            lineHeight: '20px',
            color: colors_1.tannerSemantic.info.color,
            '&.MuiTypography-colorPrimary': {
                color: '#0066ED',
            },
            '&:hover': {
                color: colors_1.tannerSemantic.info.color,
                textDecoration: 'underline',
            },
            '&:active': {
                color: colors_1.tannerSemantic.info.color,
            },
            '&:Mui-focusVisible': {
                outline: '2px solid' + colors_1.tannerSemantic.info.color,
                border: "3px solid ".concat(colors_1.tannerWhite),
            },
            '&[disabled]': {
                color: colors_1.tannerSemantic.info.color,
                cursor: 'default',
                opacity: 0.3,
                pointerEvents: 'none',
            },
            '& svg': {
                fill: 'currentColor',
                height: '16px',
                width: '16px',
            },
        },
    },
};
//# sourceMappingURL=MuiLink.js.map